import { useNavigate } from 'react-router';
import { MapPin, Plus, Truck, Zap, type LucideIcon } from 'lucide-react';

interface QuickAction {
  icon: LucideIcon;
  label: string;
  description: string;
  iconBg: string;
  iconColor: string;
  to: string;
}

const ACTIONS: QuickAction[] = [
  {
    icon: Plus,
    label: 'New Order',
    description: 'Create a transport job',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600',
    to: '/orders/new',
  },
  {
    icon: Truck,
    label: 'Orders',
    description: 'View all active jobs',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-600',
    to: '/orders',
  },
  {
    icon: MapPin,
    label: 'Locations',
    description: 'Pickup & delivery points',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
    to: '/locations',
  },
  {
    icon: Zap,
    label: 'Resources',
    description: 'Drivers, vehicles & trailers',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
    to: '/settings/resources',
  },
];

/** Quick-action grid at the bottom of the dashboard. */
export function QuickActions() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {ACTIONS.map(({ icon: Icon, label, description, iconBg, iconColor, to }) => (
        <button
          key={label}
          type="button"
          onClick={() => navigate(to)}
          className="flex cursor-pointer items-start gap-3 rounded-md border border-slate-200 bg-white p-3 text-left transition-colors hover:bg-slate-50"
        >
          <div
            className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md ${iconBg}`}
          >
            <Icon className={`h-4 w-4 ${iconColor}`} />
          </div>
          <div>
            <div className="text-xs font-semibold text-slate-700">{label}</div>
            <div className="mt-0.5 text-[11px] leading-tight text-slate-400">{description}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
